import { render, staticRenderFns } from "./personalTermsPopup.vue?vue&type=template&id=214c25de&scoped=true&"
import script from "./personalTermsPopup.vue?vue&type=script&lang=js&"
export * from "./personalTermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./personalTermsPopup.vue?vue&type=style&index=0&id=214c25de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c25de",
  null
  
)

export default component.exports